import { toZonedTime as fnsToZonedTime } from 'date-fns-tz';

import data from '@/public/ssr-cache.json';

/**
 * Gets the store's timezone centrally.
 * @returns {string} The timezone (e.g. 'America/Los_Angeles').
 */
export function getStoreTimezone(): string {
  const store = data?.store as { timezone?: string };
  const tz = store?.timezone ?? 'US/Pacific';
  return tz;
}

const TIMEZONE = getStoreTimezone();

/**
 * Converts a given date to the store's timezone.
 * Any date, including Prismic ISO dates, will be converted to the store's
 * timezone with the correct offset.
 * @param date - The date to convert (string, Date, or number).
 * @returns {Date} A Date object representing the correct time in the store's timezone.
 */
export function toZonedDate(date: Date | string | number = new Date()): Date {
  try {
    const sourceDate = date ? new Date(date) : new Date();
    return fnsToZonedTime(sourceDate, TIMEZONE);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error converting date to zoned time:', error);
    return new Date(date);
  }
}
